import { holidays } from '../../../lib/apiList'
import axios from '../../../lib/axios'
import { AddHoliday } from '../slice/types'

export const addHoliday = async (data: AddHoliday) => {
    const response = await axios.post(holidays.CREATE_HOLIDAY, data)
    return response
}

interface GetHolidaysParams {
    search: string
    currentPage: number
    recordsPerPage: number
}

export const getAllHolidays = async ({
    search,
    currentPage,
    recordsPerPage,
}: GetHolidaysParams) => {
    const data = {
        advancedSearch: {
            fields: search ? ['Title'] : [],
            keyword: search || '',
        },
        pageNumber: currentPage ? currentPage : 1,
        pageSize: recordsPerPage ? recordsPerPage : 5,
        orderBy: ['holidayDate asc'],
    }
    const response = await axios.post(holidays.GET_HOLIDAYS, data)
    return response
}

export const deleteHoliday = async (id: string) => {
    const response = await axios.delete(`${holidays.DEL_HOLIDAY}`, {
        data: { id: id },
    })
    return response.data
}

export const editHoliday = async (data: AddHoliday) => {
    const response = await axios.put(`${holidays.PUT_HOLIDAY}`, data)
    return response.data
}
